import { LINK } from '@constants';
import { AddUser, Icon, Point, RefundPoint, TwoUser } from '@viewup/ui';

export const menuList = [
  {
    icon: <Icon color='icon.brand' size='XS' source={TwoUser} />,
    text: '계정 관리',
    type: 'account-setting',
    url: LINK.MY_VIEWUP_ACCOUNT,
  },
  {
    icon: <Icon color='icon.brand' size='XS' source={AddUser} />,
    text: '계정 추가',
    type: 'account-add',
    url: LINK.ACCOUNT_ADD,
  },
  {
    icon: <Icon color='icon.point' size='XS' source={Point} />,
    text: '뷰업 포인트',
    type: 'viewing-money',
    url: LINK.VIEWING_MONEY,
  },
  {
    icon: <Icon color='icon.point' size='XS' source={RefundPoint} />,
    text: '환급신청',
    type: 'refund',
    url: LINK.MY_VIEWUP_REFUND,
  },
];
